var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.324464 4.40793C0.114328 4.21709 0.00570678 3.96321 0.000213481 3.7076C-0.00520657 3.45206 0.0925741 3.19416 0.294288 2.99542C0.495855 2.79682 0.764295 2.69402 1.03449 2.6889C1.30484 2.68363 1.57738 2.77583 1.78766 2.96681L3.60316 4.619L7.21767 0.276527L7.34717 0.369974L7.21753 0.276111C7.22786 0.263435 7.23957 0.252628 7.25261 0.243831C7.46766 0.067674 7.73756 -0.0118494 8.00138 0.00172778V0.00145069L8.01428 0.00255903C8.27964 0.0191841 8.53885 0.130711 8.73024 0.332706C8.92492 0.538095 9.01318 0.798971 8.99846 1.05396H8.99875L8.99758 1.06615C8.98029 1.31262 8.8664 1.55347 8.65999 1.73337L4.32219 6.72714L4.32249 6.72741C4.31436 6.73718 4.3052 6.74556 4.29524 6.7529C4.09213 6.92158 3.83563 7.00429 3.5806 7.00013C3.32344 6.99591 3.06679 6.90343 2.86713 6.72194L0.324464 4.40793Z",
    fill: "#00BF7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/check-mark-icon.00adc39326f7ab96356f8d4ffd63ede4.svg";
export { ForwardRef as ReactComponent };